import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const jobTypes = {
  ...addAsyncActionPostfixes({
    SAVE_CURRENT_JOB: 'SAVE_CURRENT_JOB',
    UNSAVE_CURRENT_JOB: 'UNSAVE_CURRENT_JOB'
  })
};

export const saveCurrentJob = createAsyncAction(jobTypes.SAVE_CURRENT_JOB, (id, userId) =>
  api.post(`v1/job/save-job`, { JobId: id, UserId: userId }).then((res) => ({ ...res.data }))
);

export const unsaveCurrentJob = createAsyncAction(jobTypes.UNSAVE_CURRENT_JOB, (id) =>
  api.delete(`v1/job/remove-saved-job?jobId=${id}`).then((res) => ({ ...res.data }))
);
